import AboutBanner from "parts/AboutBanner";
import Footer from "parts/Footer";
import Header from "parts/Header";
import IndustriesServe from "parts/IndustriesServe";
import ProblemWeSolve from "parts/ProblemWeSolve";
import WhoWeServe from "parts/WhoWeServe";
import React, { useEffect } from "react";

import { Helmet } from "react-helmet-async";

const SolutionsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <>
      <Helmet>
        <title>
          Solutions | Custom Software, Website & App Development | Scode
          Software Solutions
        </title>
        <meta
          name="description"
          content="At Scode Software Solutions, we serve a diverse range of clients, from budding entrepreneurs and small businesses to established corporations. We cater to:"
        />
        <link rel="canonical" href="https://www.scodesoft.com/solutions" />
      </Helmet>

      <Header />
      <AboutBanner />
      <WhoWeServe />
      <IndustriesServe />
      <ProblemWeSolve />
      <Footer />
    </>
  );
};

export default SolutionsPage;
